import { Filter, FilterType } from '@120wateraudit/envirio-components'
import { CommunicationInstanceAllMappedStatus } from '@120wateraudit/communications-types'
import { FilterMap } from 'src/containers/Grid'

export const auditLogFilters: FilterMap = {
  status: {
    key: 'status',
    label: 'Status',
    value: 'status',
    type: FilterType.ListSelection,
    options: Object.values(CommunicationInstanceAllMappedStatus).map(s => ({
      text: s,
      value: s
    }))
  },
  communicationType: {
    key: 'communicationType',
    label: 'Communication Type',
    value: 'communicationType',
    type: FilterType.ListSelection,
    options: [
      {
        text: 'Email',
        value: 'Email'
      },
      {
        text: 'Letter',
        value: 'Letter'
      }
    ]
  }
}

export const sendDateFilter: Filter = {
  key: 'auditGridCreatedOn',
  label: 'Send Date',
  value: 4,
  type: FilterType.ListSelection,
  options: [
    {
      text: 'Today',
      value: 0
    },
    {
      text: 'This week',
      value: 1
    },
    {
      text: 'This month',
      value: 2
    },
    {
      text: 'This year',
      value: 3
    },
    {
      text: 'All',
      value: 4
    }
  ]
}
